/**
 * English - `ui`: the few words the shared primitives in `components/ui` and
 * `components/data` say on their own - a dialog's close button, the route
 * loading fallback, the colour pickers, the rich text toolbar and the list
 * toolkit every merchant panel screen is built from. Anything a caller passes
 * in (a label, a title) is the caller's to translate.
 *
 * Keys: `<component>.<snake>`; `rich_text.blocks.<tag>` for the text style
 * options, by the HTML tag they apply. Conventions: see `common.ts`.
 */
const ui: Record<string, string> = {
  'modal.close': 'Close',

  'info_tip.about': 'More about {label}',

  'route_fallback.loading': 'Loading…',

  'status_dot.up': 'status: up',
  'status_dot.down': 'status: down',
  'status_dot.unknown': 'status: unknown',

  'color.not_set': 'Not set',
  'color.clear': 'Clear',
  'color.clear_named': 'Clear {label}',
  'color.colours': 'Colours',
  'color.colour_n': 'Colour {number}',
  'color.remove_colour_n': 'Remove colour {number}',
  'color.add_to': 'Add to {label}',

  'rich_text.text_style': 'Text style',
  'rich_text.blocks.p': 'Paragraph',
  'rich_text.blocks.h2': 'Heading',
  'rich_text.blocks.h3': 'Subheading',
  'rich_text.blocks.h4': 'Small heading',
  'rich_text.blocks.blockquote': 'Quote',
  'rich_text.bold': 'Bold',
  'rich_text.italic': 'Italic',
  'rich_text.underline': 'Underline',
  'rich_text.bulleted_list': 'Bulleted list',
  'rich_text.numbered_list': 'Numbered list',
  'rich_text.quote': 'Quote',
  'rich_text.align_left': 'Align left',
  'rich_text.align_centre': 'Align centre',
  'rich_text.align_right': 'Align right',
  'rich_text.add_link': 'Add link',
  'rich_text.remove_link': 'Remove link',
  'rich_text.clear_formatting': 'Clear formatting',
  'rich_text.formatted_view': 'Back to formatted view',
  'rich_text.edit_html': 'Edit HTML',
  'rich_text.link_address': 'Link address',
  'rich_text.link': 'Link',
  'rich_text.source_label': '{label} HTML',

  'table.sort_by': 'Sort',
  'table.sort_by_column': 'Sort by this column',
  'table.choose_columns': 'Choose columns',
  'table.columns': 'Columns',
  'table.reset_columns': 'Reset columns',
  'table.clear_selection': 'Clear selection',
  'table.select_all_rows': 'Select every row on this page',
  'table.exporting': 'Exporting…',
  'table.showing_range': 'Showing {first}–{last} of {total}',
  'table.rows_per_page': 'Rows',
  'table.pagination': 'Pagination',
  'table.go_to_page': 'Go to page {page}',
  'table.show_more': 'More',
  'table.show_less': 'Less',
  'table.show_more_about': 'More about {name}',
  'table.show_less_about': 'Less about {name}',
  'table.select_all_count': 'Select all {total}',
  'table.load_failed': 'We could not load this list',
  'table.no_matches_title': 'No matches',
  'table.no_matches_description': 'Try a different search, or clear the filters above.',

  'filters.active': 'Filters',
  'filters.clear_all': 'Clear all',
  'filters.remove': 'Remove filter {filter}',
  'filters.from': 'From',
  'filters.to': 'to',
  'filters.min': 'Min',
  'filters.max': 'Max',
  'filters.search_term': 'Search: {term}',
  'filters.between': '{from} – {to}',
  'filters.on_or_after': 'From {from}',
  'filters.on_or_before': 'Until {to}',
  'filters.at_least': '{min} and above',
  'filters.at_most': 'Up to {max}',
  'filters.and_more': '{first} +{extra}',

  'kpi.vs_previous': 'Compared with the previous period',
  'kpi.flat': 'Flat',

  'date_range.label': 'Date range',
  'date_range.custom': 'Custom range',
  'date_range.today': 'Today',
  'date_range.last_7': 'Last 7 days',
  'date_range.last_30': 'Last 30 days',
  'date_range.last_90': 'Last 90 days',
  'date_range.last_365': 'Last 12 months',
  'date_range.compare': 'Compare with previous period',

  'toast.region': 'Notifications',
};

export default ui;
